<template>
  <div class="footer_box mobile">
    <div class="footer_box_con">
      <div class="footMapShow">
        <div class="tibarShow">{{ $t('footer.sitemap') }}</div>
        <div class="mapCon clearfix">
          <div class="item">
            <span><router-link :to="{ name: 'about' }">{{ $t('footer.about') }}</router-link></span>
            <span><router-link :to="{ name: 'about' }">{{ $t('footer.about1') }}</router-link></span>
            <span><router-link :to="{ name: 'about' }">{{ $t('footer.about2') }}</router-link></span>
            <span><router-link :to="{ name: 'about' }">{{ $t('footer.about3') }}</router-link></span>
            <span><router-link :to="{ name: 'about' }">{{ $t('footer.about4') }}</router-link></span>
          </div>
          <div class="item">
            <span> <router-link slot="reference" :to="{ name: 'product', params: { id: 1 } }">{{ $t('footer.product')
                }}</router-link></span>
            <span v-for="(item, index) in cat_list1" :key="index">
              <router-link class="item" :to="{ name: 'product', params: { id: item.id } }" :key="index">
                <template v-if="currentLang == 'zh'">
                  {{ item.title }}
                </template>
                <template v-else>
                  {{ item.enTitle }}
                </template>

              </router-link>
            </span>
          </div>
          <div class="item">
            <span><router-link :to="{ name: 'esg' }">ESG</router-link></span>
          </div>
          <div class="item">
            <span><router-link :to="{ name: 'news' }">{{ $t('footer.news') }}</router-link></span>
          </div>
          <div class="item" v-if="CompanyInfo.tel!='false'">
            <span><router-link :to="{ name: 'join' }">{{ $t('footer.join') }}</router-link></span>
          </div>
          <div class="item">
            <span><router-link :to="{ name: 'contact' }">{{ $t('footer.contact') }}</router-link></span>
          </div>
          <div class="item contact1">
            <div class="code">
              <img :src="CompanyInfo.qrImg">
            </div>
            <div class="company" v-if="currentLang == 'zh'">{{ CompanyInfo.companyName }}</div>
            <div class="company" v-else>{{ CompanyInfo.companyEnName }}</div>
            <div class="tel">{{ $t('footer.hotservice') }}：{{CompanyInfo.phone}}</div>
          </div>
        </div>
      </div>

      <div class="copy" v-if="currentLang == 'zh'" v-html="CompanyInfo.copyright"></div>
      <div class="copy" v-else  v-html="CompanyInfo.enCopyright"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      CompanyInfo: {},
      cat_list1: {},
      currentLang: this.$i18n.locale
    }
  },
  created() {
    this.GetInfo();
    this.GetCat1();
  },
  methods: {
    ...mapActions([
      'setCompanyInfo'
    ]),
    GetInfo() {
      var url = "/pageapi/common/GetCompanyInfo";
      this.$http.post(url, {}).then(
        function (res) {
          if (res.data.status == 1) {
            this.CompanyInfo = res.data.ds;
            this.setCompanyInfo(res.data.ds);

          }
        }.bind(this)
      )
        .catch(function (error) { });
    },
    GetCat1() {
      var url = "/pageapi/Product/GetCat";
      this.$http.post(url, {}).then(function (res) {
        if (res.data.status == 1) {
          this.cat_list1 = res.data.ds;
          this.setCategoryList(res.data.ds);
        }
      }.bind(this)).catch(function () {
      });
    },
  }
}
</script>
